// extracted by mini-css-extract-plugin
module.exports = {"disclaimerText":"oOy_f7QPM0gC8P55dC4x8"};